import React from 'react';
import './Hero.css'; // Importer le fichier CSS

function Hero() {

  // Fonction pour gérer le clic sur la flèche de défilement
  const handleScrollDown = (event) => {
    event.preventDefault(); // Empêche le comportement de lien par défaut (saut brusque)
    // Récupère l'ID de la cible depuis l'attribut href du lien cliqué
    const targetId = event.currentTarget.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      // Fait défiler la page jusqu'à l'élément cible
      targetElement.scrollIntoView({
        behavior: 'smooth', // Active le défilement doux
        block: 'start'      // Aligne le haut de la cible avec le haut de la zone visible
      });
    }
  };

  return (
    // On utilise une <section> avec un ID pour pouvoir y lier depuis la Navbar
    <section id="hero" className="hero-section">
      {/* Div pour le contenu textuel, pour le centrer et le superposer */}
      <div className="hero-content">
        <h1 className="hero-title">Fromagerie Chez Paul</h1>
        <p className="hero-subtitle">
          L'excellence du fromage artisanal à L'Isle-Jourdain. Découvrez notre sélection affinée.
        </p>
        {/* Bouton d'appel à l'action (Call To Action) */}
        <a href="#products" className="hero-cta-button" onClick={handleScrollDown}> {/* Optionnel: Utiliser aussi handleScrollDown ici */}
          Découvrez notre Fromagerie
        </a>
      </div>

      {/* --- NOUVEAU : Flèche pour scroller vers le bas --- */}
      <a
        href="#about" /* IMPORTANT: Mettez l'ID de VOTRE section suivante ici */
        className="scroll-down-arrow"
        aria-label="Faire défiler vers le bas"
        onClick={handleScrollDown} // Appelle la fonction de défilement doux
      >
        {/* Vous pouvez utiliser une icône SVG, une image, ou un caractère,
            ou la créer en CSS comme dans l'exemple CSS ci-dessous */}
      </a>

      {/* L'overlay est géré en CSS */}
    </section>
  );
}

export default Hero;